import moment from 'moment'

export const formatSecondsToTime = noOfSeconds =>
  new Date(noOfSeconds * 1000).toISOString().substr(11, 8)

export const timeBetween = (startDate, endDate) => {
  const start = moment(startDate)
  const end = moment(endDate)

  const seconds = moment.duration(end.diff(start)).asSeconds()
  return formatSecondsToTime(seconds)
}
